import { render, staticRenderFns } from "./CardSwitch.vue?vue&type=template&id=6077a201&scoped=true&"
import script from "./CardSwitch.vue?vue&type=script&lang=js&"
export * from "./CardSwitch.vue?vue&type=script&lang=js&"
import style0 from "./CardSwitch.vue?vue&type=style&index=0&id=6077a201&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6077a201",
  null
  
)

export default component.exports